module.exports = __webpack_public_path__ + "static/media/code.184ea9e2.jpg";